import React from "react";
import { Input } from "reactstrap";
import { CustomFormProps } from "../../../../../../types/Forms";

const CustomFormSelect: React.FC<CustomFormProps> = ({ inputId, options, title }) => {
  return (
    <Input type="select" id={inputId}>
      <option>{title}</option>
      {options.map((item, i) => (
        <option key={i} value={i}>
          {item}
        </option>
      ))}
    </Input>
  );
};
export default CustomFormSelect;
